import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-forbit",
  "use": "icon-forbit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-forbit\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 953.6a441.6 441.6 0 1 1 0-883.2 441.6 441.6 0 0 1 0 883.2z m0-64a377.6 377.6 0 1 0 0-755.2 377.6 377.6 0 0 0 0 755.2z\" p-id=\"1422\" fill=\"#ffffff\" /><path d=\"M182.1696 227.4304l45.2608-45.2608 614.4 614.4-45.2608 45.2608z\" p-id=\"1423\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol